export default __webpack_public_path__ + "static/media/ifrs9.29d12d49.svg";